import React, { useState, useRef, useEffect } from 'react';
import { useClickOutside } from '../../hooks/useClickOutside';
import { safeToLowerCase } from './utils/StringUtils';
import Dropdown from './components/Dropdown';
import DropdownButton from './components/DropdownButton';

const MultiSelect = ({
  options = [],
  selectedValues = [],
  onChange,
  placeholder = 'Select items...',
  showSearch = true,
  triggerElement,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [dropdownPosition, setDropdownPosition] = useState('bottom');
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);

  useClickOutside(containerRef, () => setIsOpen(false));

  useEffect(() => {
    if (isOpen && dropdownRef.current && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;
      const windowHeight = window.innerHeight;
      const spaceBelow = windowHeight - containerRect.bottom;
      const spaceAbove = containerRect.top;

      setDropdownPosition(spaceBelow < dropdownHeight && spaceAbove > spaceBelow ? 'top' : 'bottom');
    }
  }, [isOpen]);

  const filteredOptions = options.filter(option =>
    safeToLowerCase(option?.label).includes(safeToLowerCase(search))
  );

  const handleToggleOption = (option) => {
    const isSelected = selectedValues.some(item => item?.value === option?.value);
    const newSelected = isSelected
      ? selectedValues.filter(item => item?.value !== option?.value)
      : [...selectedValues, option];
    onChange(newSelected);
  };

  const handleTriggerClick = (e) => {
    // Prevent form submission when clicking the trigger
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(!isOpen);
    if (!isOpen) setSearch('');
  };

  return (
    <div 
      className="relative w-full" 
      ref={containerRef} 
      style={{ zIndex: isOpen ? 1000 : 1 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      <div 
        onClick={handleTriggerClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            handleTriggerClick(e);
          }
        }}
      >
        {triggerElement || (
          <DropdownButton
            isOpen={isOpen}
            placeholder={placeholder}
          />
        )}
      </div>

      {isOpen && (
        <Dropdown
          dropdownRef={dropdownRef}
          dropdownPosition={dropdownPosition}
          showSearch={showSearch}
          searchValue={search}
          onSearchChange={setSearch}
          filteredOptions={filteredOptions}
          selectedValues={selectedValues}
          onToggleOption={handleToggleOption}
        />
      )}
    </div>
  );
};

export default MultiSelect;